export const ERROR_CODE_SEARCH_PARAM = 'error_code';
export const ERROR_DESCRIPTION_SEARCH_PARAM = 'error_description';
